export default __webpack_public_path__ + "static/media/copy-link.b353f2bb.png";